// Copyright (c) 2024 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
import { ActivityType } from "./collision-data.js";
export class CollisionDataReader {
    /**
     * Read collision data from parsed JSON.
     * @param theJson - parsed JSON.
     * @returns collision data.
     */
    static readCollisionJson(theJson, theCollisionData) {
        const activities = theJson.activities;
        const readContour = (theContour) => {
            if (!Array.isArray(theContour) || theContour.length == 0) {
                return new Array();
            }
            let aSegments = Array.from({ length: theContour.length });
            for (let anIdx = 0; anIdx < theContour.length; anIdx++) {
                const aValue = theContour[anIdx];
                const aFrom = { x: aValue[0][0], y: aValue[0][1], z: aValue[0][2] };
                const aTo = { x: aValue[1][0], y: aValue[1][1], z: aValue[1][2] };
                aSegments[anIdx] = { from: aFrom, to: aTo };
            }
            return aSegments;
        };
        const readCollision = (theCollision, theTotalSteps) => {
            if (!Array.isArray(theCollision) || theCollision.length == 0) {
                return new Array();
            }
            let aCollision = Array.from({ length: theTotalSteps }, () => []);
            for (let anIdx = 0; anIdx < theCollision.length; anIdx++) {
                var aValue = theCollision[anIdx];
                aCollision[aValue.step] = aValue.hasOwnProperty('contour') ? readContour(aValue.contour)
                    : [...aValue.intersections];
            }
            return aCollision;
        };
        const readActivity = (theActivity) => {
            const aTotalSteps = theActivity.total_steps;
            const aCollisions = theActivity.collisions;
            const anActivity = {
                totalCollisions: theActivity.total_collisions,
                totalSteps: aTotalSteps,
                collisions: readCollision(aCollisions, aTotalSteps),
                isContour: aCollisions.length > 0 && aCollisions[0].hasOwnProperty('contour')
            };
            return anActivity;
        };
        for (const activityName of Object.keys(ActivityType)) {
            const fieldName = ActivityType[activityName];
            if (activities.hasOwnProperty(fieldName)) {
                theCollisionData[fieldName] = readActivity(activities[fieldName]);
            }
        }
        return theCollisionData;
    }
}
